import { render, staticRenderFns } from "./detail-warranty-individual.vue?vue&type=template&id=658148b3&scoped=true&"
import script from "./detail-warranty-individual.vue?vue&type=script&lang=js&"
export * from "./detail-warranty-individual.vue?vue&type=script&lang=js&"
import style0 from "./detail-warranty-individual.vue?vue&type=style&index=0&id=658148b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658148b3",
  null
  
)

export default component.exports